import React from 'react';
import ToggleButtonGroupMui from '@mui/material/ToggleButtonGroup';

/**
 * ToggleButtonGroup — universal styled group for toggle buttons.
 *
 * This component is a drop-in replacement for MUI ToggleButtonGroup with unified styles for the app.
 * All MUI ToggleButtonGroup props are supported.
 *
 * @component
 * @example
 * // Exclusive selection
 * <ToggleButtonGroup
 *   value={selected}
 *   exclusive
 *   onChange={handleChange}
 *   size="small"
 *   color="primary"
 *   sx={{ my: 2 }}
 * >
 *   <ToggleButton value="left">Left</ToggleButton>
 *   <ToggleButton value="right">Right</ToggleButton>
 * </ToggleButtonGroup>
 *
 * // Multiple selection
 * <ToggleButtonGroup
 *   value={selectedArray}
 *   onChange={handleChange}
 *   color="secondary"
 * >
 *   <ToggleButton value="bold">Bold</ToggleButton>
 *   <ToggleButton value="italic">Italic</ToggleButton>
 * </ToggleButtonGroup>
 *
 * @param {object} props - All MUI ToggleButtonGroup props are supported, including sx for custom styles.
 */
const ToggleButtonGroup = ({ sx = {}, ...props }) => {
  return (
    <ToggleButtonGroupMui
      {...props}
      sx={{
        bgcolor: 'background.paper',
        borderRadius: '16px',
        p: 0.5,
        gap: 0.5,
        '& .MuiToggleButton-root': {
          border: 'none',
          borderRadius: '12px !important',
          p: 1.5,
          minWidth: 'auto',
          '&.Mui-selected': {
            bgcolor: 'background.default',
          },
          '&:hover': {
            bgcolor: (theme) => theme.palette.action.hover,
          },
        },
        ...sx,
      }}
    />
  );
};

export default ToggleButtonGroup;
